const POI_FAVOURITES_KEY = 'poi_favourites';
const HEATMAP_FAVOURITES_KEY = 'heatmap_favourites';

export const getPoiFavouritesFromLocalStorage = (): string[] => {
  const localStorageValue = localStorage.getItem(POI_FAVOURITES_KEY);
  return localStorageValue ? JSON.parse(localStorageValue) : [];
};

export const setPoiFavouritesFromLocalStorage = (favourites: string[]) => {
  localStorage.setItem(POI_FAVOURITES_KEY, JSON.stringify(favourites));
};

export const getHeatmapFavouritesFromLocalStorage = (): string[] => {
  const localStorageValue = localStorage.getItem(HEATMAP_FAVOURITES_KEY);
  return localStorageValue ? JSON.parse(localStorageValue) : [];
};

export const setHeatmapFavouritesFromLocalStorage = (favourites: string[]) => {
  localStorage.setItem(HEATMAP_FAVOURITES_KEY, JSON.stringify(favourites));
};
